var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('round-dates',{attrs:{"start-date":{
    datetime: _vm.scoreSet.galleryStartDate,
    timezone: _vm.scoreSet.galleryStartTimezone
  },"end-date":{
    datetime: _vm.scoreSet.galleryEndDate,
    timezone: _vm.scoreSet.galleryEndTimezone
  }},on:{"updated":_vm.onUpdated}})}
var staticRenderFns = []

export { render, staticRenderFns }